module.exports = __webpack_public_path__ + "img/HavalKwestani-AwRozhana.6c960340.jpg";